import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container-fluid py-4" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-4" }
const _hoisted_3 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-title mb-0" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_12 = { class: "mt-2" }
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "flex-grow-1" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "mt-3" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  key: 0,
  class: "card-footer bg-light"
}
const _hoisted_23 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center gap-3 mt-3 mb-4 flex-wrap px-3"
}
const _hoisted_26 = { class: "d-flex align-items-center gap-2" }
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "pagination-mini" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = ["disabled", "onClick"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background-color":"rgba(0,0,0,0.5)"}
}
const _hoisted_33 = { class: "modal-dialog modal-lg" }
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "modal-header" }
const _hoisted_36 = { class: "modal-title" }
const _hoisted_37 = { class: "modal-body" }
const _hoisted_38 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "mb-3" }
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = { class: "mb-3" }
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status"
}

import { ref, computed, onMounted, defineAsyncComponent } from 'vue';
import apiService from '@/services/apiService';
// import zeroConfiguration from '@/components/commen/table/zeroConfiguration.vue';
import CommonTable2 from '@/components/commen/table/CommonTable2.vue';
import { usePermissions } from '@/composables/usePermissions';

interface Sheet {
  _id: string;
  icon: {
    prefix: string;
    iconName: string;
    _id?: string;
  } | null;
  variables: {
    'sheet-title': string;
    'sheet-description': string;
    'sheet-icon'?: {
      prefix: string;
      iconName: string;
    };
  };
  workspace_id: string;
  workspace_module_id: string;
  is_ai_generated: boolean;
  created_at: string;
  updated_at: string | null;
  module: {
    _id: string;
    variables: {
      'module-title': string;
      'module-icon'?: {
        prefix: string;
        iconName: string;
      };
    };
    is_default: boolean;
  };
  workspace: {
    _id: string;
    title: string;
  };
  created_by: {
    _id: string;
    name: string;
    email: string;
  };
}

interface Module {
  _id: string;
  title?: string;
  variables?: {
    'module-title'?: string;
  };
}

// Reactive state

export default /*@__PURE__*/_defineComponent({
  __name: 'SheetsList',
  setup(__props) {

const { canCreate } = usePermissions();

// Define IconUploader as async component
const IconUploader = defineAsyncComponent({
  loader: () => import('@/components/commen/modal/IconUploader.vue'),
  loadingComponent: {
    template: `
      <div class="text-center py-3">
        <div class="spinner-border spinner-border-sm" role="status"></div>
        <span class="ms-2">Loading icon picker...</span>
      </div>
    `
  },
  errorComponent: {
    template: `
      <div class="alert alert-warning">
        <small>Icon picker unavailable. Using manual selection.</small>
      </div>
    `
  },
  delay: 200,
  timeout: 3000
});

// Types
const activeTab = ref<'default' | 'byusers'>('default');
const isLoading = ref(false);
const error = ref<string | null>(null);
const sheets = ref<Sheet[]>([]);
const defaultModules = ref<Module[]>([]);
const showModal = ref(false);
const isEditMode = ref(false);
const isSaving = ref(false);
const editingSheetId = ref<string | null>(null);

// --- Pagination State ---
const tablePagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0,
  total_pages: 0,
  has_next: false,
  has_prev: false,
});

const visiblePages = computed(() => {
  const total = tablePagination.value.total_pages;
  const current = tablePagination.value.current_page;

  if (!total || total <= 4) {
    return Array.from({ length: Math.max(1, total) }, (_, i) => i + 1);
  }

  const pages: (number | string)[] = [];
  pages.push(1);

  if (current > 4) pages.push("...");

  const windowStart = Math.max(2, current - 1);
  const windowEnd = Math.min(total - 1, current + 1);
  for (let i = windowStart; i <= windowEnd; i++) pages.push(i);

  if (current < total - 3) pages.push("...");

  pages.push(total);
  return pages;
});

// Form data
const formData = ref({
  workspace_module_id: '',
  variables: {
    'sheet-title': '',
    'sheet-description': '',
    'sheet-icon': null as { prefix: 'fa-solid' | 'fa-regular' | 'fa-brands' | 'fa-light' | 'fa-thin' | 'fa-duotone' | 'fa-sharp-solid' | 'fa-sharp-duotone'; iconName: string } | null
  }
});

// Computed properties
const currentTabTitle = computed(() => 
  activeTab.value === 'default' ? 'Default Sheets' : 'By Users Sheets'
);

const currentSheetIcon = computed(() => formData.value.variables['sheet-icon']);

// Table configuration for zeroConfiguration component
const tableConfig = computed(() => ({
  data: processedSheets.value,
  columns: [
    { name: "Icon", field: "display_icon", sortable: false },
    { name: "Title", field: "sheet_title", sortable: true },
    { name: "Description", field: "sheet_description", sortable: false },
    { name: "Module", field: "module_title", sortable: true },
    { name: "Workspace", field: "workspace_title", sortable: true },
    { name: "Created By", field: "created_by_name", sortable: true },
    { name: "Created", field: "created_at", sortable: true, type: "date" },
  ],
  actions: activeTab.value === 'default' ? [true] : [false], // Only show actions for default tab
  loading: isLoading.value,
  showCategoryFilter: false,
  showStatusFilter: false,
  table_width: "max-content",
}));

const changeRows = async () => {
  tablePagination.value.current_page = 1;
  await fetchSheets(1, tablePagination.value.per_page);
};

const handlePageChange = async (page: number) => {
  if (page < 1 || page === tablePagination.value.current_page) return;
  if (page > tablePagination.value.total_pages) return;

  await fetchSheets(page, tablePagination.value.per_page);
};

// Process sheets data for table display
const processedSheets = computed(() => 
  sheets.value.map(sheet => ({
    ...sheet,
    display_icon: sheet.variables?.['sheet-icon']?.iconName 
      ? `<i class="${sheet.variables['sheet-icon'].prefix || 'fa'} ${sheet.variables['sheet-icon'].iconName}"></i>`
      : '<i class="fa fa-file-alt text-muted"></i>',
    sheet_title: sheet.variables?.['sheet-title'] || 'Untitled Sheet',
    sheet_description: sheet.variables?.['sheet-description'] || 'No description',
    module_title: sheet.module?.variables?.['module-title'] || 'Unknown Module',
    workspace_title: sheet.workspace?.title || 'Unknown Workspace',
    created_by_name: sheet.created_by?.name || 'Unknown User'
  }))
);

// Methods
const setActiveTab = (tab: 'default' | 'byusers') => {
  activeTab.value = tab;
  tablePagination.value.current_page = 1;
  fetchSheets(1, tablePagination.value.per_page);
};

const fetchSheets = async (page = 1, limit = 10) => {
  isLoading.value = true;
  error.value = null;
  
  try {
    console.log(`Fetching ${activeTab.value} sheets...`);
    const isDefault = activeTab.value === 'default';
    const endpoint = `common/with-module-info?is_default=${isDefault}`;
    const response = await apiService.get(endpoint, { page, limit });
    console.log('Sheets API Response:', response);
    console.log('Response type:', typeof response);
    console.log('Response keys:', response ? Object.keys(response) : 'null/undefined');
    
    // Handle multiple possible response formats
    let sheetsData: Sheet[] = [];
    
    if (response && response.data && Array.isArray(response.data.sheets)) {
      // Format: { status, message, data: { sheets: [...] } }
      sheetsData = response.data.sheets;
    } else if (response && Array.isArray(response.sheets)) {
      // Format: { sheets: [...] }
      sheetsData = response.sheets;
    } else if (Array.isArray(response)) {
      // Format: [...]
      sheetsData = response;
    } else if (Array.isArray(response.data)) {
      // Format: { data: [...] }
      sheetsData = response.data;
    } else {
      console.error('Unexpected response structure:', response);
      console.error('Response data:', response?.data);
      throw new Error(`Invalid response format. Got: ${typeof response}, expected sheets array`);
    }
    
    sheets.value = sheetsData;
    console.log(`Loaded ${sheets.value.length} ${activeTab.value} sheets`);

    // backend gives pagination object
    if (response.pagination) {
      tablePagination.value.current_page = response.pagination.current_page || page;
      tablePagination.value.total_pages = response.pagination.total_pages || 1;
      tablePagination.value.total = response.pagination.total || sheetsData.length;
      tablePagination.value.has_prev = (response.pagination.current_page || page) > 1;
      tablePagination.value.has_next =
        (response.pagination.current_page || page) < (response.pagination.total_pages || 1);
    } else {
      // Fallback if no pagination metadata
      tablePagination.value.current_page = page;
      tablePagination.value.total_pages = 1;
      tablePagination.value.total = sheetsData.length;
      tablePagination.value.has_prev = false;
      tablePagination.value.has_next = false;
    }
  } catch (err: any) {
    console.error('Error fetching sheets:', err);
    error.value = err?.response?.data?.message || err?.message || 'Failed to load sheets';
    sheets.value = [];
  } finally {
    isLoading.value = false;
  }
};

const fetchDefaultModules = async () => {
  try {
    console.log('Fetching default modules for sheet creation...');
    const response = await apiService.get('/common/workspace-modules-filter', { 
      is_default: true 
    });
    
    if (Array.isArray(response)) {
      defaultModules.value = response;
      console.log(`Loaded ${defaultModules.value.length} default modules`);
    }
  } catch (err: any) {
    console.error('Error fetching default modules:', err);
  }
};

const openCreateModal = () => {
  isEditMode.value = false;
  editingSheetId.value = null;
  resetForm();
  showModal.value = true;
  fetchDefaultModules();
};

const resetForm = () => {
  formData.value = {
    workspace_module_id: '',
    variables: {
      'sheet-title': '',
      'sheet-description': '',
      'sheet-icon': {
        prefix: 'fa-solid',
        iconName: ''
      }
    }
  };
};

const ensureIconObject = () => {
  if (!formData.value.variables['sheet-icon']) {
    formData.value.variables['sheet-icon'] = {
      prefix: 'fa-solid',
      iconName: ''
    };
  }
};

const updateIconPrefix = (event: Event) => {
  ensureIconObject();
  const target = event.target as HTMLSelectElement;
  if (formData.value.variables['sheet-icon']) {
    formData.value.variables['sheet-icon'].prefix = target.value as any;
  }
};

const updateIconName = (event: Event) => {
  ensureIconObject();
  const target = event.target as HTMLInputElement;
  if (formData.value.variables['sheet-icon']) {
    formData.value.variables['sheet-icon'].iconName = target.value.startsWith('fa-') 
      ? target.value 
      : `fa-${target.value}`;
  }
};

const closeModal = () => {
  showModal.value = false;
  isEditMode.value = false;
  editingSheetId.value = null;
  resetForm();
};

const saveSheet = async () => {
  if (!formData.value.variables['sheet-title']?.trim()) {
    alert('Please enter a sheet title');
    return;
  }

  if (!isEditMode.value && !formData.value.workspace_module_id) {
    alert('Please select a module');
    return;
  }

  isSaving.value = true;
  
  try {
    const payload = {
      ...formData.value,
      // Clean up empty icon
      variables: {
        ...formData.value.variables,
        'sheet-icon': formData.value.variables['sheet-icon']?.iconName 
          ? formData.value.variables['sheet-icon'] 
          : undefined
      }
    };

    if (isEditMode.value && editingSheetId.value) {
      await apiService.put('/common/cms-sheets', editingSheetId.value, payload);
      console.log('Sheet updated successfully');
    } else {
      await apiService.post('/common/cms-sheets', payload);
      console.log('Sheet created successfully');
    }
    
    closeModal();
    await fetchSheets(tablePagination.value.current_page, tablePagination.value.per_page);
  } catch (err: any) {
    console.error('Error saving sheet:', err);
    alert('Failed to save sheet: ' + (err?.response?.data?.message || err?.message || 'Unknown error'));
  } finally {
    isSaving.value = false;
  }
};

// Event handlers for zeroConfiguration table
const handleEdit = (sheet: any) => {
  if (activeTab.value !== 'default') {
    console.log('Edit action not allowed for By Users sheets');
    return;
  }
  
  isEditMode.value = true;
  editingSheetId.value = sheet._id;
  
  formData.value = {
    workspace_module_id: sheet.workspace_module_id,
    variables: {
      'sheet-title': sheet.variables?.['sheet-title'] || '',
      'sheet-description': sheet.variables?.['sheet-description'] || '',
      'sheet-icon': sheet.variables?.['sheet-icon'] || {
        prefix: 'fa',
        iconName: ''
      }
    }
  };
  
  showModal.value = true;
};

const handleView = (sheet: any) => {
  console.log('Viewing sheet:', sheet);
  alert(`Sheet: ${sheet.sheet_title}\nModule: ${sheet.module_title}\nWorkspace: ${sheet.workspace_title}\nCreated by: ${sheet.created_by_name}`);
};

const handleDelete = async (id: string) => {
  if (activeTab.value !== 'default') {
    console.log('Delete action not allowed for By Users sheets');
    return;
  }
  
  if (!confirm("Are you sure you want to delete this sheet?")) return;
  
  try {
    console.log('Deleting sheet:', id);
    await apiService.delete('/common/cms-sheets', id);
    
    await fetchSheets(tablePagination.value.current_page, tablePagination.value.per_page);
    console.log('Sheet deleted successfully');
  } catch (err: any) {
    console.error('Error deleting sheet:', err);
    alert('Failed to delete sheet: ' + (err?.message || 'Unknown error'));
  }
};

// Lifecycle
onMounted(() => {
  fetchSheets(tablePagination.value.current_page, tablePagination.value.per_page);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          _createElementVNode("li", _hoisted_4, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'default' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setActiveTab('default'))),
              type: "button"
            }, " Default ", 2)
          ]),
          _createElementVNode("li", _hoisted_5, [
            _createElementVNode("button", {
              class: _normalizeClass(["nav-link", { active: activeTab.value === 'byusers' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (setActiveTab('byusers'))),
              type: "button"
            }, " By Users ", 2)
          ])
        ]),
        (activeTab.value === 'default')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: openCreateModal,
              disabled: !_unref(canCreate)('main')
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", { class: "fa fa-plus me-2" }, null, -1),
              _createTextVNode(" Create New Sheet ", -1)
            ]))], 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h5", _hoisted_9, _toDisplayString(currentTabTitle.value), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                ], -1)),
                _createElementVNode("p", _hoisted_12, "Loading " + _toDisplayString(activeTab.value === 'default' ? 'Default' : 'By Users') + " sheets...", 1)
              ]))
            : (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
                    _createElementVNode("div", _hoisted_15, [
                      _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Error:", -1)),
                      _createTextVNode(" " + _toDisplayString(error.value), 1)
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-outline-danger",
                      onClick: fetchSheets
                    }, [...(_cache[12] || (_cache[12] = [
                      _createElementVNode("i", { class: "fa fa-refresh" }, null, -1),
                      _createTextVNode(" Retry ", -1)
                    ]))])
                  ])
                ]))
              : (sheets.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(CommonTable2, {
                      tableObj: tableConfig.value,
                      title: '',
                      permissionKey: "main",
                      onEdit: handleEdit,
                      onDelete: handleDelete,
                      onView: handleView
                    }, null, 8, ["tableObj"])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mb-3" }, [
                      _createElementVNode("i", { class: "fa fa-file-alt fa-3x text-muted" })
                    ], -1)),
                    _createElementVNode("h5", _hoisted_18, "No " + _toDisplayString(activeTab.value === 'default' ? 'Default' : 'By Users') + " Sheets Found", 1),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(activeTab.value === 'default' 
              ? 'No default sheets are available.' 
              : 'No By Users sheets are available.'), 1),
                    _createElementVNode("div", _hoisted_20, [
                      (activeTab.value === 'default')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-primary me-2",
                            onClick: openCreateModal,
                            disabled: !_unref(canCreate)('main')
                          }, [...(_cache[14] || (_cache[14] = [
                            _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                            _createTextVNode(" Create Sheet ", -1)
                          ]))], 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        class: "btn btn-outline-secondary",
                        onClick: fetchSheets
                      }, [...(_cache[15] || (_cache[15] = [
                        _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                        _createTextVNode(" Refresh ", -1)
                      ]))])
                    ])
                  ]))
        ]),
        (sheets.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("small", _hoisted_24, " Showing " + _toDisplayString(sheets.value.length) + " " + _toDisplayString(activeTab.value === 'default' ? 'default' : 'By Users') + " sheet" + _toDisplayString(sheets.value.length !== 1 ? 's' : ''), 1),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-outline-secondary",
                  onClick: fetchSheets
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("i", { class: "fa fa-refresh me-1" }, null, -1),
                  _createTextVNode(" Refresh ", -1)
                ]))])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (sheets.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-muted" }, "Rows per page:", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select form-select-sm rows-select",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tablePagination.value.per_page) = $event)),
                onChange: changeRows
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([5, 10, 20, 50, 100], (n) => {
                  return _createElementVNode("option", {
                    key: n,
                    value: n
                  }, _toDisplayString(n), 9, _hoisted_27)
                }), 64))
              ], 544), [
                [
                  _vModelSelect,
                  tablePagination.value.per_page,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("button", {
                class: "page-btn prev_btn",
                disabled: !tablePagination.value.has_prev,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handlePageChange(tablePagination.value.current_page - 1)))
              }, " « ", 8, _hoisted_29),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (p, index) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: index,
                  class: _normalizeClass(["page-btn", {
            'page-active': p === tablePagination.value.current_page,
            'disabled-dots': p === '...',
          }]),
                  disabled: p === '...',
                  onClick: ($event: any) => (p !== '...' && typeof p === 'number' && handlePageChange(p))
                }, _toDisplayString(p), 11, _hoisted_30))
              }), 128)),
              _createElementVNode("button", {
                class: "page-btn next_btn",
                disabled: !tablePagination.value.has_next,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (handlePageChange(tablePagination.value.current_page + 1)))
              }, " » ", 8, _hoisted_31)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h5", _hoisted_36, _toDisplayString(isEditMode.value ? 'Edit' : 'Create') + " Sheet ", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: closeModal,
                  "aria-label": "Close"
                })
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("form", {
                  onSubmit: _withModifiers(saveSheet, ["prevent"])
                }, [
                  (!isEditMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", {
                          for: "moduleSelect",
                          class: "form-label"
                        }, [
                          _createTextVNode("Select Module "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "moduleSelect",
                          class: "form-select",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.workspace_module_id) = $event)),
                          required: ""
                        }, [
                          _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "-- Select Module --", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultModules.value, (module) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: module._id,
                              value: module._id
                            }, _toDisplayString(module.variables?.['module-title'] || module.title || 'Untitled Module'), 9, _hoisted_39))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, formData.value.workspace_module_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_40, [
                    _cache[21] || (_cache[21] = _createElementVNode("label", {
                      for: "sheetTitle",
                      class: "form-label"
                    }, [
                      _createTextVNode("Sheet Title "),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "sheetTitle",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.variables['sheet-title']) = $event)),
                      placeholder: "Enter sheet title",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formData.value.variables['sheet-title']]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _cache[22] || (_cache[22] = _createElementVNode("label", {
                      for: "sheetDescription",
                      class: "form-label"
                    }, "Sheet Description", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control",
                      id: "sheetDescription",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.variables['sheet-description']) = $event)),
                      rows: "3",
                      placeholder: "Enter sheet description"
                    }, null, 512), [
                      [_vModelText, formData.value.variables['sheet-description']]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "form-label" }, "Sheet Icon", -1)),
                    _createVNode(_unref(IconUploader), {
                      modelValue: formData.value.variables['sheet-icon'],
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.variables['sheet-icon']) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ], 32)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: closeModal
                }, "Cancel"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: saveSheet,
                  disabled: isSaving.value || !formData.value.variables['sheet-title']?.trim()
                }, [
                  (isSaving.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_45))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(isSaving.value ? 'Saving...' : (isEditMode.value ? 'Update' : 'Create')), 1)
                ], 8, _hoisted_44)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})